import { useState } from 'react';
import { sb } from '../../../lib/supabase';

export default function ExchangeRates({ fx, orgId, profile, setError, reload }) {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [rate, setRate] = useState('');
  const [date, setDate] = useState('');

  async function add() {
    if (!from || !to || !rate || !date) return;
    setError(null);
    const { error: e } = await sb.from('resource_fx_rates').insert({
      organisation_id: orgId,
      from_currency: from.toUpperCase(),
      to_currency: to.toUpperCase(),
      rate: Number(rate),
      effective_date: date,
      created_by: profile?.id || null,
    });
    if (e) setError(e.message);
    else { setFrom(''); setTo(''); setRate(''); setDate(''); reload(); }
  }

  async function remove(id) {
    setError(null);
    const { error: e } = await sb.from('resource_fx_rates').delete().eq('id', id);
    if (e) setError(e.message);
    else reload();
  }

  function fmtDate(d) {
    if (!d) return '';
    const dt = new Date(`${d}T00:00:00`);
    return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  return (
    <div className="rd-pane">
      <div className="rd-chead">
        <div>
          <h2>Exchange rates</h2>
          <p>Dated pairs — multiple rates per currency, effective by date.</p>
        </div>
      </div>
      <div className="rd-list-panel">
        {(fx || []).length === 0 ? (
          <div className="rd-empty">No rates yet.</div>
        ) : fx.map((x) => (
          <div key={x.id} className="rd-lrow">
            <span>
              {x.from_currency} → {x.to_currency}
              <span className="rd-meta"> {x.rate} · from {fmtDate(x.effective_date)}</span>
            </span>
            <span className="rd-acts">
              <button type="button" className="rd-link muted" onClick={() => remove(x.id)}>Remove</button>
            </span>
          </div>
        ))}
        <div className="rd-add-row">
          <input type="text" className="form-input" style={{ width: 90 }} placeholder="From (GBP)" value={from} onChange={(e) => setFrom(e.target.value)} />
          <input type="text" className="form-input" style={{ width: 90 }} placeholder="To (USD)" value={to} onChange={(e) => setTo(e.target.value)} />
          <input type="number" className="form-input" style={{ width: 80 }} placeholder="Rate" value={rate} onChange={(e) => setRate(e.target.value)} />
          <input type="date" className="form-input" value={date} onChange={(e) => setDate(e.target.value)} />
          <button type="button" className="rd-add-btn" onClick={add}>+ Add rate</button>
        </div>
      </div>
    </div>
  );
}
